import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Created' },
    { value: 2, label: 'Updated' },
    { value: 3, label: 'Unchanged' },
    { value: 4, label: 'Skipped' },
    { value: 5, label: 'Failed' },
  ],
});
